import React, { useState, useEffect } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import { BookOpen, Search, Menu, X, GraduationCap } from 'lucide-react';
import Home from './pages/Home';
import Chapters from './pages/Chapters';
import SearchPage from './pages/Search';
import ItemDetail from './pages/ItemDetail';
import './App.css';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: '首页', icon: BookOpen },
    { path: '/chapters', label: '章节', icon: GraduationCap },
    { path: '/search', label: '搜索', icon: Search },
  ];

  return (
    <div className="app">
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          <NavLink to="/" className="logo">
            <GraduationCap size={32} />
            <div className="logo-text">
              <span className="logo-title">
                <span className="logo-title-full">学训一百条</span>
                <span className="logo-title-short">学训一百条</span>
              </span>
            </div>
          </NavLink>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `nav-link ${isActive ? 'active' : ''}`
                }
              >
                <item.icon size={18} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-nav"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="nav-mobile" id="mobile-nav" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `nav-link-mobile ${isActive ? 'active' : ''}`
                }
                onClick={() => setMobileMenuOpen(false)}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        )}
      </header>

      <main className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chapters" element={<Chapters />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/item/:number" element={<ItemDetail />} />
        </Routes>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <p className="footer-motto">顶天立地，造福天下！</p>
          <p className="footer-spirit">厚德 · 博学 · 弘毅 · 敦行</p>
          {/* <p className="footer-copyright">
            安徽扬子职业技术学院 · 志存高远，奔向辉煌!
          </p> */}
        </div>
      </footer>
    </div>
  );
}

export default App;
